import { Slide } from 'react-toastify'
import { getEnv } from 'utils/env'

const env = process.env.NODE_ENV === 'production' ? `${getEnv()}_` : ''

const config = {
    APP_NAME: 'ZEISS Surgical Cloud',
    API_BASE_URL: process.env[`REACT_APP_${env}API_BASE_URL`],
    MAXIMUM_API_RETRIES: 3,
    HOME_PAGE_ROUTE: '/',
    LANDING_PAGE_ROUTE: '/surgical-cloud',
    DEFAULT_DATE_FORMAT: 'dd.MM.yyyy',
    SUBSCRIPTION: {
        MAX_USER_INVITATIONS: 5,
    },
    LANGUAGES: ['en-US', 'en'],
    DEFAULT_LANGUAGE: 'en',

    /*
     * Time should be in minutes
     * `env` will be `true` for production environment and `false` for development(localhost)
     */
    IDLE_TIMER: env ? 20 : 120,
    BUILD_NUMBER: process.env.REACT_APP_VERSION,
}

export const toast = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: true,
    transition: Slide,
    newestOnTop: true,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: false,
    draggable: true,
    pauseOnHover: true,
    limit: 5,
}

export default config
